import { useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useAppData } from '../store';
import { CATEGORY_EMOJI } from '../types';
import ObligationCard from './ObligationCard';
import AssetForm from './AssetForm';
import * as db from '../lib/db';

export default function AssetDetail() {
  const { assetId } = useParams();
  const { assets, obligations, remindersByObligation, refresh } = useAppData();
  const [editing, setEditing] = useState(false);
  const navigate = useNavigate();

  const asset = assets.find((a) => a.id === assetId);
  if (!asset) return <div className="empty-state">Asset not found.</div>;

  const assetObligations = obligations
    .filter((o) => o.asset_id === asset.id && o.active)
    .sort((a, b) => (a.due_date < b.due_date ? -1 : 1));

  async function handleDelete() {
    if (!asset) return;
    if (!confirm(`Delete ${asset.name}? Its obligations will be kept but unlinked.`)) return;
    await db.deleteAsset(asset.id);
    await refresh();
    navigate('/assets');
  }

  if (editing) {
    return (
      <AssetForm
        existing={asset}
        onCancel={() => setEditing(false)}
        onDone={() => setEditing(false)}
      />
    );
  }

  return (
    <div className="asset-detail">
      <div className="page-header">
        <h1>
          {CATEGORY_EMOJI[asset.category]} {asset.name}
        </h1>
        <div className="page-header-actions">
          <button className="btn-secondary" onClick={() => setEditing(true)}>
            Edit
          </button>
          <button className="btn-secondary danger" onClick={handleDelete}>
            Delete
          </button>
        </div>
      </div>

      {asset.description && <p>{asset.description}</p>}
      {asset.location && <p className="muted">📍 {asset.location}</p>}
      {asset.notes && <p className="notes">{asset.notes}</p>}

      <div className="section-header">
        <h2>Obligations</h2>
        <Link to="/obligations/new" state={{ assetId: asset.id }} className="btn-primary small">
          + Add
        </Link>
      </div>

      {assetObligations.length === 0 ? (
        <p className="muted empty">Nothing tracked for {asset.name} yet.</p>
      ) : (
        <div className="card-list">
          {assetObligations.map((o) => (
            <ObligationCard key={o.id} obligation={o} reminders={remindersByObligation[o.id]} />
          ))}
        </div>
      )}
    </div>
  );
}
